import { gsap,Power3 } from "gsap";
import { Presentation, PresentationState } from '../../../../core/gameflow/controller/Presentation';
import { GameData } from '../../../server/data/GameData';
import { StateHandler } from "../../../../core/utils/StateHandler";
import { SanEngineManager } from "../../../engine/SanEngineManager";
import { SanQuentin2 } from "../../../SanQuentin2";
import { SoundManager } from "../../../config/sound/SoundManager";
import { SoundConfig } from "../../../config/sound/SoundConfig";
import { RevealerManager } from "../../../modules/revealer/RevealerManager";
import { ArrayHelper } from "../../../../core/utils/ArrayHelper";
import { Helper } from "../../../../core/utils/Helper";

enum SetupResultState {
    SHOW_RESULT,
    APPLY_VALUE,
    UNLOCK_REELS,
}

export class SetupResultPresentation extends Presentation {

    protected didHit: boolean = false;
    private state = new StateHandler(undefined, new Map<any, Function>([
        [SetupResultState.SHOW_RESULT, () => this.onRevealSymbols()],
        [SetupResultState.APPLY_VALUE, () => this.onApplyValue()],
        [SetupResultState.UNLOCK_REELS, () => this.onUnlockReels()],
    ]));
    private symReveal:string;
    private symVal:number;

    constructor() {
        super();
    }

    setGameData(data: GameData): void {
        super.setGameData(data);
        this.state.set(SetupResultState.SHOW_RESULT)
        this.symReveal = data.Reel.convictedMysterySymbol ? data.Reel.convictedMysterySymbol : "M3";
        this.symVal = data.Reel.convictedMysteryMultiplier;

        for(let k = 0; k < this._gameData.raw.numJumpingWilds;k++){
            const jw = SanQuentin2.jumpingWildController.getExistingItem(k);
            if(SanQuentin2.jumpingWildController.items.length > 3) jw.changeMult(2);

            jw.position = Helper.copyLocalPosition(jw, SanQuentin2.setupPhase.setupJWSyms[k]);
            jw.alpha = 0;
        }
    }

    public createPresentation(enableSkip: Function) {
        this.state.triggerState(enableSkip);
    }

    onRevealSymbols():void{

        SoundManager.playSoundEffect(SoundConfig.SETUP_2_CELL_EXPLODE);
        ArrayHelper.eachForEach(this._gameData.Reel.evalReel,(reel,row,val) => {
            if(val == "Z") {
                this.timeline.add(() => { 
                    SanEngineManager.AllReels[reel].getSymbol(row)!.explodeReveal(this.symReveal)
                }, 0);
            }
        });

        this.timeline.to(this,{duration: 0.5},0);
        this.state.set(SetupResultState.APPLY_VALUE)
    }

    onApplyValue():void{
        SoundManager.playSoundEffect(SoundConfig.SETUP_2_COLLECT_VALUES);
        this.timeline.add(SanQuentin2.setupPhase.CollectValue(this.symVal));

        let offset:number = this.timeline.totalDuration() - 0.5;

        ArrayHelper.eachForEach(this._gameData.Reel.evalReel,(reel,row,val) => {
            if(val == "Z") {
                this.timeline.add(() => { 
                    SoundManager.playSoundEffect(SoundConfig.SETUP_2_APPLY_VALUES);
                    SanEngineManager.AllReels[reel].getSymbol(row)!.isSpecial(this.symVal)}, offset);
                offset += 0.1;
            }
        })

        this.timeline.to(this, { duration: offset }, 0);
        
        this.state.set(SetupResultState.UNLOCK_REELS)
    }

    onUnlockReels():void{

        if(this._gameData.raw.topBottomReelOpened.includes(false))
            SoundManager.playSoundEffect(SoundConfig.CELL_OPEN_REMAINING);

        SanEngineManager.RAll(reel => { this.timeline.add(reel.reelLocker(false), 0);})

        SanQuentin2.setupPhase.removeOverlay();
        this.timeline.add(SanQuentin2.setupPhase.removeSides());
        this.timeline.add(SanQuentin2.reelEngineManager.applyBars(true),"-=0.6");
        
        this.timeline.to(this,{ duration:0.5 },"-=0.6");
        this.setPlayable(false);
        this.timeline.add(() => {SoundManager.stopSoundEffect(SoundConfig.FS_INTRO_AMBIANCE)},0.375);
        this.timeline.add(() => {SoundManager.PlayAmbience(SoundConfig.FS_GAME_AMBIANCE)},0.375);
    }

    skip(): void {
        super.skip();
    }

    done(): void {
    }
}